export const IDENTITY_AUTH_BASE_PATH = 'v1/autenticacao';
export const IDENTITY_USER_BASE_PATH = 'v1/usuario';

export const PUBLIC_IDENTITY_API_ROUTES = [
  `${IDENTITY_AUTH_BASE_PATH}/cadastro`,
  `${IDENTITY_AUTH_BASE_PATH}/login`,
  `${IDENTITY_AUTH_BASE_PATH}/redefinirSenha`,
  `${IDENTITY_AUTH_BASE_PATH}/gerarNovaSenha`,
  `${IDENTITY_USER_BASE_PATH}/busca-equipes`
];
